import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import classnames from 'classnames/bind';
import styles from './preparation.module.scss';
const cx = classnames.bind(styles);

const JobPreparationMbti = () => {
  return (
    // 취준 MBTI 영역
    <div className={cx('preparationListArea')}>
      <em className={cx('preparationTitle')}>취준 MBTI</em>
      <ul className={cx('preparationList')}>
        <li className={cx('listItem')}>
          <Link href={'https://acca.jobda.im/jbti/me'} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('icon')}>
                <Icon name="matchingYellow" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>취뽀 유형 테스트</div>
                <p className={cx('infoDesc')}>
                  간단 테스트로 나의 취업 능력을 알아보세요.
                  <br />내 강약점부터 추천 직무까지 받아볼 수 있어요.
                </p>
              </div>
            </a>
          </Link>
        </li>
      </ul>
    </div>
  );
};
export default JobPreparationMbti;
